module.exports = __webpack_public_path__ + "static/media/trailer.386ed9c9.svg";